var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlob4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 564,
    height: 533,
    viewBox: "0 0 564 533",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M454.686 113.025C509.705 160.828 568.331 196.906 562.92 240.199C557.508 282.591 488.058 332.198 447.47 370.982C406.883 408.864 395.157 435.922 374.413 446.745C353.668 456.667 323.904 449.451 278.806 470.196C234.611 490.941 175.082 538.744 142.612 532.43C110.142 526.117 103.828 465.686 75.868 406.158C47.9077 345.727 -2.60137 287.101 0.104469 235.69C2.81031 184.279 59.633 140.083 117.358 93.182C175.984 46.2807 234.611 -4.22832 290.531 0.281412C346.452 5.6931 398.765 65.2216 454.686 113.025Z",
    fill: "url(#paint0_linear_18_455)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_455",
    x1: 0,
    y1: 533,
    x2: 532.188,
    y2: -29.4098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F87537"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBA81F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob4);
export default __webpack_public_path__ + "static/media/blob 4.f852663ea98fe039078fd23bb611780a.svg";
export { ForwardRef as ReactComponent };